import { profileVerified } from "assets";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, X } from "lucide-react";
import { useState } from "react";
import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  post: any;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}
export default function NewFeedDailogDeletePost({ post, isDialogOpen, setIsDialogOpen }: DialogProps) {
  const { showDialogConfirm } = appStore();
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmit, setloadingSubmit] = useState<boolean>(false);

  const submitDeletePost = async (id: any) => {
    setloadingSubmit(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeletePost;
      url += `token=${token}`;
      const data = {
        post_id: id,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setloadingSubmit(false);
            setIsDialogOpen(false);
            // onUploadSuccess({
            //   res: responses.user_shop_product,
            //   name: "delete",
            // });
          }
        })
        .catch((err) => {
          setloadingSubmit(false);
        });
    } catch (error) {
      setloadingSubmit(false);

      AppLog.show({
        message: `[submitDeletePost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const userPost = post.re_post_user ? post.re_post_user : post.user;

  return (
    <>
      <Dialog open={isDialogOpen}>
        <DialogContent
          onWheel={(e) => {
            e.stopPropagation();
          }}
          isShowBtnXClose={false}
          className="max-w-full lg:max-w-[800px] h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 "
        >
          <DialogHeader>
            <DialogTitle className=" text-start flex justify-center items-center">Delete Post</DialogTitle>
            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => setIsDialogOpen(false)}
            >
              <X />
            </div>
          </DialogHeader>
          <ScrollArea className="mt-2 gap-3  pr-[20px] pb-[50px]">
            <div className="flex flex-row justify-between items-center space-x-2 ">
              <ImageUrlProfile user={userPost} className="w-[50px] h-[50px] rounded-full object-cover border shadow-md" isLinkProfile={true} />
              <div className="hidden xl:flex flex-row justify-between items-center w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-2">
                    <p className="text-sm font-medium">{userPost?.name}</p>
                    {userPost?.is_verified === "Yes" && <img src={profileVerified} alt="" style={{ width: 15, height: 15 }} />}
                  </div>
                  <div className="flex items-center space-x-2">
                    <p className="text-xs">
                      {`${userPost.no_of_follower ? `${userPost?.no_of_follower} Followers` : ""}
                                    ${userPost.no_of_like ? `• ${userPost?.no_of_like} Likes` : ""}
                                `}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <br />
            {/* ===========Description Title=============== */}

            <p className="">
              We understand that sometimes you may want to remove a post from your profile — whether it’s temporary or permanent. That’s why we’ve made it easy for you to delete
              your post while still giving you the option to bring it back later if you change your mind.
            </p>

            <ScrollBar orientation="vertical" />
          </ScrollArea>
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
            <button
              onClick={() =>
                showDialogConfirm({
                  titileButtonSubmit: "Yes, Delete",
                  titileButtonCancel: "No, Cancel",
                  title: "Delete",
                  message: "Do you want to Delete ?",
                  onSubmit() {
                    submitDeletePost(post.post_id);
                  },
                })
              }
              className="w-full mt-6   bg-red-500 text-white text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
            >
              {loadingSubmit ? <Loader className="animate-spin" /> : "Delete"}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

